const subuserStatementsHR = {
    "view": {
        "table": {
            "title": "Popis izjava vašeg podkorisnika",
            "column": {
                "type": "Tip",
                "year": "Godina",
                "month": "Mjesec",
                "issue_year": "Godina izdavanja",
                "issue_month": "Mjesec izdavanja",
                "description": "Opis",
                "amount": "Iznos",
                "status": "Status",
                "details": "Detalji",
                "overview": "Pregled",
                "action": "Akcija"
            },
            "button": {
                "export_csv": "Izvezi CSV",
                "download": "Preuzmi"
            },
            "placeholder": {
                "search": "Pretraži..."
            },
            "label": {
                "statusOpen": "Otvoreno",
                "statusPaid": "Plaćeno",
                "typeLicensing": "Licenciranje",
                "typeRegular": "Redovno",
                "typeAudioMasteringServices": "Audio Mastering - Usluge",
                "typeVinylEarnings": "Zarada od vinila",
                "typeOffset": "Offset",
                "typeNotKnown": "Nepoznato",
                "monthJanuary": "Siječanj",
                "monthFebruary": "Veljača",
                "monthMarch": "Ožujak",
                "monthApril": "Travanj",
                "monthMay": "Svibanj",
                "monthJune": "Lipanj",
                "monthJuly": "Srpanj",
                "monthAugust": "Kolovoz",
                "monthSeptember": "Rujan",
                "monthOctober": "Listopad",
                "monthNovember": "Studeni",
                "monthDecember": "Prosinac"
            },
            "dropdown": {
                "markAsPaid": "Označi kao PLAĆENO",
                "markAsOpen": "Označi kao OTVORENO",
                "action": "Akcija"
            },
            "message": {
                "statementUnavailable": "Sve izjave izdane prije siječnja 2023. dostupne su kao ZIP privici u vašem e-mailu."
            }
        },
        "message": {
            "successMarkedOpen": "Izjava podkorisnika je označena kao OTVORENA!",
            "successMarkedPaid": "Izjava podkorisnika je označena kao PLAĆENA!",
            "error": "Nešto je pošlo po zlu! Osvježite stranicu i pokušajte ponovo!"
        },
        "modal": {
            "markAsPaid": {
                "header": "Označi izjavu kao PLAĆENU",
                "body": "Jeste li sigurni da želite označiti izjavu {{statementName}} kao PLAĆENU?"
            },
            "markAsOpen": {
                "header": "Označi izjavu kao OTVORENU",
                "body": "Jeste li sigurni da želite označiti izjavu {{statementName}} kao OTVORENU?"
            }
        }
    },
    "viewOnly": {
        "table": {
            "title": "Popis vaših izjava",
            "column": {
                "name": "Naziv izjave",
                "type": "Tip",
                "quarter": "Kvartal",
                "year": "Godina",
                "month": "Mjesec",
                "description": "Opis",
                "amount": "Iznos",
                "status": "Status",
                "overview": "Pregled",
                "details": "Detalji"
            },
            "button": {
                "download": "Preuzmi",
                "export_csv": "Izvezi CSV"
            },
            "placeholder": {
                "search": "Pretraži..."
            },
            "label": {
                "statusOpen": "Otvoreno",
                "statusPaid": "Plaćeno",
                "typeLicensing": "Licenciranje",
                "typeRegular": "Redovno",
                "typeAudioMasteringServices": "Audio Mastering - Usluge",
                "typeVinylEarnings": "Zarada od vinila",
                "typeOffset": "Offset",
                "typeNotKnown": "Nepoznato",
                "quarterQ1": "Q1",
                "quarterQ2": "Q2",
                "quarterQ3": "Q3",
                "quarterQ4": "Q4",
                "monthJanuary": "Siječanj",
                "monthFebruary": "Veljača",
                "monthMarch": "Ožujak",
                "monthApril": "Travanj",
                "monthMay": "Svibanj",
                "monthJune": "Lipanj",
                "monthJuly": "Srpanj",
                "monthAugust": "Kolovoz",
                "monthSeptember": "Rujan",
                "monthOctober": "Listopad",
                "monthNovember": "Studeni",
                "monthDecember": "Prosinac"
            },
            "message": {
                "statementUnavailable": "Sve izjave izdane prije siječnja 2023. poslane su putem e-pošte vašem voditelju računa."
            }
        }
    }
};

export default subuserStatementsHR;